export default {
  id: 26,
  title: 'Target #26 - Smiley',
  url: 'https://cssbattle.dev/play/26',
  colors: ['#6592CF', '#060F55'],
  solution:
    '<a a><a b><a c><style>body{background:#6592cf}a{position:fixed;border:20px solid #060f55;width:80;height:80;border-radius:50%;clip:rect(auto,auto,60,auto)}a[a],a[b]{top:40}a[a]{left:40}a[b]{right:40}a[c]{bottom:40;left:140;transform:rotate(180deg)}</style>',
}
